import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27723 24996"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970272559264">
        <path
          d="M12819 14478c227 611-80 1292-685 1521-605 230-1280-80-1507-691L8246 8895c-227-611 79-1293 684-1522 606-229 1280 81 1507 692l2382 6413zM9831 3458c0 1849-1515 3348-3384 3348S3063 5307 3063 3458c0-1850 1515-3349 3384-3349s3384 1499 3384 3349z"
          className="fil0"
        />
        <path
          d="M9946 16340c0 698-571 1269-1269 1269H4217c-698 0-1269-571-1269-1269V8494c0-697 571-1268 1269-1268h4460c698 0 1269 571 1269 1268v7846z"
          className="fil0"
        />
        <path
          d="M6097 23404c0 879-706 1592-1576 1592s-1576-713-1576-1592v-9223c0-879 706-1591 1576-1591 871 0 1576 713 1576 1591v9223zM9949 23404c0 879-706 1592-1576 1592s-1576-713-1576-1592v-9223c0-879 706-1591 1576-1591 871 0 1576 713 1576 1591v9223zM75 14478c-227 611 80 1292 685 1521 605 230 1280-80 1507-691l2382-6413c227-611-80-1293-685-1522s-1280 81-1507 692L75 14478z"
          className="fil0"
        />
      </g>
      <g id="_1970272560160">
        <circle
          r={65448}
          className="fil0"
          transform="matrix(.01181 -.05033 .05033 .01181 20956.4 3384.28)"
        />
        <path
          d="M20748 23359c0 870-543 1576-1211 1576-669 0-1211-706-1211-1576v-9132c0-871 542-1576 1211-1576 668 0 1211 705 1211 1576v9132zM23590 23359c0 870-542 1576-1211 1576s-1211-706-1211-1576v-9132c0-871 542-1576 1211-1576s1211 705 1211 1576v9132z"
          className="fil0"
        />
        <path
          d="M25906 18273c99 539-269 981-818 981h-8144c-550 0-909-440-799-978l1836-10308c110-538 649-715 1198-715h3923c549 0 1079 179 1178 719l1626 10301z"
          className="fil0"
        />
        <path
          d="M27611 14286c275 591 24 1295-561 1571-585 277-1282 23-1557-569l-2887-6201c-275-592-24-1295 561-1572s1282-22 1557 569l2887 6202zM14389 14240c-286 586-47 1294 532 1582 580 287 1282 45 1568-541l2998-6149c286-585 47-1294-532-1581-580-287-1282-46-1567 541l-2999 6148z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
